@if (model && model.OrganizationResponsible) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <risk-linkable
            #linkable
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [hideActions]="true"
            [orderByValueProperty]="true"
            (linkedChange)="linkedChanged($event)"
            [disabled]="disabled"
            [showAdvancedFilters]="true"
            [activeFilters]="activeFilters"
            [moduleType]="moduleType"
        >
        </risk-linkable>
    }
} @else {
    <div>{{ 'risks.selectOrgResponsibleFirst' | t }}</div>
}
